import {StringUtils, Utils} from '../Utils/index';
import {assign} from 'lodash';
import {RawResponseType} from "./Types";

/**
 * @class ResponseBase - abstract class for all client api responses
 */
export abstract class ResponseBase {
    private _validateErrors: Array<string> = [];

    constructor(data?: RawResponseType) {
        if (!StringUtils.isNullOrEmpty(data as string)) {
            var json = data;
            if (typeof data === 'string') {
                json = Utils.tryParseJson(data as string);
            }

            if (!Utils.isNullOrUndefined(json)) {
                assign(this, json);
            }
        }
    }

    /**
     * @method validate - validating if response has expected structure.
     * @returns true when response structure is valid, otherwise returns false.
     */
    public validate(): boolean {
        this._validateErrors = [];
        this.internalValidate(this._validateErrors);
        return this._validateErrors.length === 0;
    }

    /**
     * @method getValidateErrors - returns list of validation errors.
     * Method @validate must be called prior this method.
     * @returns list of strings where each item represent separate error.
     */
    public getValidateErrors(): Array<string> {
        return this._validateErrors;
    }

    /**
     * @method internalValidate - descendats will overwrite this method and made custom validations.
     * @param errors - list of output erros where to populate errors.
     */
    protected abstract internalValidate(errors: Array<string>): void;
}


/** WEBPACK FOOTER **
 ** ./Engine/ApiClient/ResponseBase.ts
 **/